<template>
  <div class="tiaolionline">
    <div class="tlolti">{{ titext }}</div>
    <div class="tltltext">
      <textarea
        placeholder="请输入案情经过和维权诉求，尽量详实以得到更精准的解答"
      ></textarea>
    </div>
    <div class="kszxbtn">快速咨询</div>
  </div>
</template>

<script>
export default {
  props: {
    titext: {
      type: String,
      default: "在线咨询“婚姻家庭”专业律师",
    },
  },
};
</script>

<style lang="scss" scoped>
.tiaolionline {
  width: 100%;
  height: 100%;
  padding: 36px 16px 0;
  background: url("../../../assets/tiaolidetail/tiaolionlinebg.png");
  .tlolti {
    font-size: 18px;
    color: #333333;
    text-align: center;
  }
  .tltltext {
    margin: 22px 0;
    textarea {
      width: 100%;
      height: 150px;
      background: #fcfcff;
      border: 1px solid #eff1fd;
      border-radius: 5px;
      padding: 28px 19px;
      font-size: 12px;
      color: #666666;
      line-height: 20px;
    }
  }
  .kszxbtn {
    cursor: pointer;
    width: 140px;
    height: 36px;
    text-align: center;
    line-height: 36px;
    margin: 0 auto;
    background: #f25717;
    border-radius: 18px;
    font-size: 18px;
    color: #ffffff;
  }
}
</style>